import type { UserProfile } from '@generated/agent';

import type { MyInfo } from '@/stores/AuthStore';

export type InitialProfile = UserProfile;
export type { CreateSessionResponse } from '@generated/agent';

const GENDER_TO_SHORT = { 남자: '남', 여자: '여' } as const;

const toGenderShort = (gender?: string) => {
  if (!gender || !(gender in GENDER_TO_SHORT)) {
    return undefined;
  }

  return GENDER_TO_SHORT[gender as keyof typeof GENDER_TO_SHORT];
};

export const buildInitialProfile = (
  myInfo: MyInfo | null | undefined,
): InitialProfile | undefined => {
  if (!myInfo) {
    return undefined;
  }

  const entries = Object.entries({
    age: myInfo.age,
    gender: toGenderShort(myInfo.gender),
    ctpv_nm: myInfo.region,
    sgg_nm: myInfo.subRegion,
    monthly_income: myInfo.salary,
  }).filter(([, value]) => value !== undefined);

  if (entries.length === 0) {
    return undefined;
  }

  return Object.fromEntries(entries) as InitialProfile;
};

export const buildGreetingMessage = (myInfo: MyInfo | null | undefined) => {
  if (!myInfo) {
    return '안녕하세요';
  }

  const region = [myInfo.region, myInfo.subRegion].filter(Boolean).join(' ');
  const parts = [
    myInfo.age !== undefined ? `${myInfo.age}세` : undefined,
    region ? `${region} 거주` : undefined,
    myInfo.gender,
  ].filter(Boolean);

  if (parts.length === 0) {
    return '안녕하세요';
  }

  return `안녕하세요\n\n저는 ${parts.join(' / ')} 입니다`;
};
